import CloseWhiteboardDialog from 'features/whiteboard/modals/CloseWhiteboardDialog';

const CloseWhiteboardConfirmationModal = () => (
  <CloseWhiteboardDialog
    modalName="closeWhiteboardConfirmation"
    translationKey="close_whiteboard_confirmation"
  />
);

export default CloseWhiteboardConfirmationModal;
